type GenericEventWithStopPropagation = Pick<Event, 'stopPropagation'>;

export const stopPropagation = (event: GenericEventWithStopPropagation) => event.stopPropagation();
